// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2EqcT","title":"Header_title__33hBS","side":"Header_side__39Jzh"};